<template>
    <v-app v-if="$auth.ready()">
        <router-view></router-view>
        <toaster />
    </v-app>
</template>

<script>
import Toaster from "./components/Toaster";

export default {
    name: "App",
    components: { Toaster },
};
</script>
